// extracted by mini-css-extract-plugin
export default {"link":"MatchLink-module--link--IRaKG"};